<div class="is-relative">
    <a
        class="has-text-black close-button"
        (click)="closeForm()"
        ><i class="fas fa-times"></i
    ></a>
</div>
<ng-content></ng-content>
<ng-template [ngIf]="loading && !error">Loading {{ title }} ...</ng-template>
<ng-template [ngIf]="error">Error Loading {{ title }}</ng-template>
